
// BRAND LOGOS
export const CS_LOGO = 'images/logos/cryptoshots-logo.png';
export const CC_LOGO = 'images/logos/cryptochess-logo.png';
export const CC_LOGO_SMALL = 'images/logos/cryptochess-logo-small.png';

// CHAIN LOGOS
export const HIVE_LOGO = 'images/logos/hive-logo.png';
export const BTC_LOGO = 'images/logos/bitcoin-logo.png';
export const ETH_LOGO = 'images/logos/ethereum-logo.png';

export const SOCIAL_ICONS = {
  GROUP: 'images/socials/socials-group.png',

  TWITTER: 'images/socials/x-icon.png',
  DISCORD: 'images/socials/discord-icon.png',
  WEBSITE: 'images/socials/web-icon.png',
  HIVE_BLOG: 'images/socials/hiveblog-icon.png',

  FACEBOOK: 'images/socials/facebook-icon.png',
  TIKTOK: 'images/socials/tiktok-icon.png',
  YOUTUBE: 'images/socials/youtube-icon.png',
  INSTAGRAM: 'images/socials/instagram-icon.png',
};

